<div class="panel panel-form" [ngClass]="{ open: open }">
  <lib-form-header [open]="open" [header]="header" [required]="required" (openChange)="open = $event"></lib-form-header>
  @if (open && form) {
    <div class="panel-content">
      <form [formGroup]="form">
        <!-- MAIN -->
        <div class="row">
          @for (key of order; track key) {
            @if (key !== 'instances_infinite' && key !== 'instances_allow_exceed_amount') {
              <div
                class="col-12 col-sm-4 form-field-container"
                [ngClass]="{ inactive: getProductVariants().length > 0 && !voucherActive }"
              >
                <div class="form-field-label">
                  {{ 'form.field.' + key | transloco }}
                </div>
                <mat-form-field
                  class="form-field"
                  [floatLabel]="'auto'"
                  [ngClass]="{ readonly: key === 'instances_available' && voucherActive && !voucherGenerateCodes }"
                >
                  <input
                    matInput
                    [type]="key === 'instances_available' ? 'number' : 'text'"
                    [formControlName]="key"
                    [readonly]="
                      options.length > 0 || (key === 'instances_available' && voucherActive && !voucherGenerateCodes)
                    "
                  />
                  @if (getFormControl(key).invalid) {
                    <mat-error>
                      @if (getFormControl(key).errors.required) {
                        {{ 'form.error.required' | transloco }}
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            } @else {
              <div class="col-12 form-field-container mb-2">
                @if (key === 'instances_allow_exceed_amount') {
                  <mat-checkbox class="checkbox d-block" [formControlName]="key">
                    {{ 'product.' + key | transloco }}
                  </mat-checkbox>
                }
                @if (key === 'instances_infinite') {
                  <mat-checkbox
                    class="checkbox d-block"
                    [checked]="!getFormControl(key).value"
                    (change)="updateTrackingAmount($event.checked)"
                  >
                    {{ 'product.' + key | transloco }}
                  </mat-checkbox>
                }
              </div>
            }
          }
          @if (!(voucherActive && !voucherGenerateCodes)) {
            <div class="col-12 col-sm-auto mt-3" [ngClass]="{ 'mb-4': options.length > 0 }">
              <button type="button" class="btn btn-secondary d-block w-100" (click)="addOption()">
                {{ 'product.add_option' | transloco }}
                <div
                  class="i-icon i-icon-btn"
                  #tooltip="matTooltip"
                  [matTooltip]="'tooltip.product.add_new_option' | transloco"
                  [matTooltipPosition]="'above'"
                  (click)="tooltip.toggle()"
                >
                  <span class="i">i</span>
                </div>
              </button>
            </div>
          }
        </div>
        <!-- MAIN -->
      </form>
      @if (!(voucherActive && !voucherGenerateCodes)) {
        <!-- OPTIONS -->
        @for (option of options; track option; let i = $index) {
          <div class="row flex-sm-nowrap mt-2">
            <div class="col col-sm-4 form-field-container order-2 order-sm-1">
              <div class="form-field-label required">{{ 'global.option' | transloco }} {{ i + 1 }}</div>
              <mat-form-field class="form-field" [floatLabel]="'auto'">
                <input matInput [(ngModel)]="option.name" />
              </mat-form-field>
            </div>
            <div class="col-12 col-sm form-field-container order-3 order-sm-2">
              <div class="form-field-label required">
                {{ 'global.variant' | transloco }}
              </div>
              <mat-form-field class="form-field" [floatLabel]="'auto'">
                <mat-chip-grid #variantsList>
                  @for (variant of option.variants; track variant) {
                    <mat-chip-row [removable]="true" (removed)="removeVariant(option, variant)">
                      {{ variant }}
                      <span matChipRemove class="icon-remove" [inlineSVG]="'/icons/icon-close.svg'"></span>
                    </mat-chip-row>
                  }
                  <input
                    [matChipInputFor]="variantsList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="false"
                    (matChipInputTokenEnd)="addVariant(option, $event)"
                  />
                </mat-chip-grid>
              </mat-form-field>
            </div>
            <div class="col-auto col-option-remove order-1 order-sm-3">
              <button class="btn btn-remove" (click)="removeOption(option)">
                <span class="icon-remove mt-4" [inlineSVG]="'/icons/icon-close.svg'"></span>
              </button>
            </div>
          </div>
        }
        <!-- OPTIONS -->
        <!-- VARIANTS -->
        @if (options.length > 0 || getProductVariants().length > 0) {
          <div class="row" [ngClass]="{ 'mt-3': options.length === 0 }">
            <div class="col-12 col-sm-auto mt-2" [ngClass]="{ 'mb-3': getProductVariants().length > 0 }">
              <button
                type="button"
                class="btn d-block w-100"
                (click)="generateVariants()"
                [ngClass]="[variantsChange ? 'btn-primary' : 'btn-secondary']"
                [disabled]="!optionsCorrect()"
              >
                {{ 'product.generate_variants' | transloco }}
              </button>
            </div>
            @for (productVariant of getProductVariants().controls; track productVariant; let i = $index) {
              <div class="col-12 mt-3">
                <form [formGroup]="productVariant | formGroup">
                  <div class="row">
                    <div class="col-6 col-sm-4 col-md-2 form-field-container">
                      <div class="form-field-label">#{{ i + 1 }} {{ 'form.field.variant' | transloco }}</div>
                      <div class="variant-descriptors">
                        @for (descriptor of productVariant.get('descriptors').value; track descriptor) {
                          <span class="variant-name">{{ descriptor.value }}</span>
                        }
                      </div>
                    </div>
                    <div class="col-6 col-sm-4 col-md-2 form-field-container">
                      <div class="form-field-label">
                        {{ 'form.field.photo' | transloco }}
                      </div>
                      <lib-photo-upload
                        [photo]="
                          productVariant.get('media').value?.length > 0
                            ? productVariant.get('media').value[0]?.url1x
                            : null
                        "
                        [layout]="2"
                        [hideInfo]="true"
                        (fileChange)="photoVariantChange(productVariant, $event)"
                      ></lib-photo-upload>
                    </div>
                    @for (key of variantOrder; track key) {
                      <div
                        class="form-field-container"
                        [ngClass]="[
                          key === 'instances_available' ? 'col-6 col-sm-4 col-md-2' : 'col-6 col-sm-4 col-md-3',
                        ]"
                      >
                        <div class="form-field-label">
                          {{ 'form.field.' + key | transloco }}
                        </div>
                        <mat-form-field class="form-field" [floatLabel]="'auto'">
                          <input
                            matInput
                            [type]="key === 'instances_available' ? 'number' : 'text'"
                            [formControlName]="key"
                          />
                          @if (productVariant.get(key).invalid) {
                            <mat-error>
                              @if (productVariant.get(key).errors.required) {
                                {{ 'form.error.required' | transloco }}
                              }
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                  </div>
                </form>
              </div>
            }
          </div>
        }
        <!-- VARIANTS -->
      }
    </div>
  }
</div>
